var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ScrollX',{attrs:{"source":"feature"}},_vm._l((_vm.creators),function(creator,i){return _c('div',{key:i,staticClass:"scroll-item"},[_c('FeaturedCreator',{attrs:{"creator":creator}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }